<div class="row mt-4">
  <div class="col-md-12">
    <mat-card class="property-card">
      <!-- Title & Subtitle on the Left -->
      <div class="mat-card-group">
        <mat-card-title class="card-heading">Trends</mat-card-title>
      </div>

      <mat-card-content>
        <div class="row">
          <div class="col-md-6 col-12">
            <h4 class="mb-3 headWrap">Key Indicators</h4>
            <table
              cellpadding="5"
              class="table table-bordered key-indicator w_100"
              *ngIf="latestData && latestData.length != 0"
            >
              <tbody>
                <tr>
                  <th style="width: 65%">
                    <label>Median List Price</label>
                  </th>
                  <td>
                    <div>${{ latestData[0]?.MedianListPrice?.[selectedPropertyKey] | number }}</div>
                  </td>
                </tr>
                <tr>
                  <th>
                    <label>Asking Price/Sqft</label>
                  </th>
                  <td>
                    <div>${{ latestData[0]?.AvgListPricePerSqft?.[selectedPropertyKey] | number }}</div>
                  </td>
                </tr>
                <tr>
                  <th>
                    <label>Average Days on Market</label>
                  </th>
                  <td>
                    <div>{{ latestData[0]?.AvgDOM?.[selectedPropertyKey] }}</div>
                  </td>
                </tr>
                <tr>
                  <th>
                    <label>New Homes Listed for Sale</label>
                  </th>
                  <td>
                    <div>{{ latestData[0]?.NewListingCount?.[selectedPropertyKey] }}</div>
                  </td>
                </tr>
                <tr>
                  <th>
                    <label>Total Sold</label>
                  </th>
                  <td>
                    <div>{{ latestData[0]?.SoldCount?.[selectedPropertyKey] }}</div>
                  </td>
                </tr>
                <tr>
                  <th>
                    <label>Median House Size (Sqft.)</label>
                  </th>
                  <td>
                    <div>{{ latestData[0]?.MedianGLA?.[selectedPropertyKey] }}</div>
                  </td>
                </tr>
                <tr>
                  <th>
                    <label>Median Number of Bedrooms</label>
                  </th>
                  <td>
                    <div>{{ latestData[0]?.MedianBed?.[selectedPropertyKey] }}</div>
                  </td>
                </tr>
                <tr>
                  <th>
                    <label>Median Number of Bathrooms:</label>
                  </th>
                  <td>
                    <div>{{ latestData[0]?.MedianBath?.[selectedPropertyKey] }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-6 col-12">
            <h4 class="mb-3 headWrap">Median List Price by Property Type</h4>
            <table cellpadding="5" class="table table-bordered w_100">
              <tbody>
                <tr>
                  <td>
                    <!-- <td style="height: 340px">&nbsp;</td> -->
                    <!-- <app-line-chart *ngIf="medianListPriceData.length != 0"
                  [chartData]="medianListPriceData"
                  [chartSettings]="medianListPriceXaxis"
                >
                </app-line-chart> -->
                    <div class="high-graph" id="mediaListPriceContainer">
                      <highcharts-chart
                        [Highcharts]="Highcharts"
                        [options]="medianListPriceChart"
                        style="width: 100%; height: 400px; display: block"
                      >
                      </highcharts-chart>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-12">
            <h4 class="mb-3 headWrap">Median Sold Price by Property Type</h4>
            <table cellpadding="5" class="table table-bordered w_100">
              <tbody>
                <tr>
                  <td>
                    <!-- <app-line-chart
                    *ngIf="medianSoldPriceData.length != 0"
                    [chartData]="medianSoldPriceData"
                    [chartSettings]="medianSoldPriceXaxis"
                  >
                  </app-line-chart> -->
                    <div class="high-graph" id="mediaSoldPriceContainer">
                      <highcharts-chart
                        [Highcharts]="Highcharts"
                        [options]="medianSoldPriceChart"
                        style="width: 100%; height: 400px; display: block"
                      >
                      </highcharts-chart>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-6 col-12">
            <h4 class="mb-3 headWrap">Average Days on Market by Property Type</h4>
            <table cellpadding="5" class="table table-bordered w_100">
              <tbody>
                <tr>
                  <td>
                    <!-- <app-line-chart
                    *ngIf="avgDomByProperty.length != 0"
                    [chartData]="avgDomByProperty"
                    [chartSettings]="avgDomXaxis"
                  >
                  </app-line-chart> -->
                    <div class="high-graph" id="averageDOMContainer">
                      <highcharts-chart
                        [Highcharts]="Highcharts"
                        [options]="averageDOMChart"
                        style="width: 100%; height: 400px; display: block"
                      >
                      </highcharts-chart>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-12">
            <h4 class="mb-3 headWrap">Median Sold Price per Sqft by Property Type</h4>
            <table cellpadding="5" class="table table-bordered w_100">
              <tbody>
                <tr>
                  <td>
                    <!-- <app-line-chart
                    *ngIf="medianSoldPricePerSqFeetData.length != 0"
                    [chartData]="medianSoldPricePerSqFeetData"
                    [chartSettings]="medianSoldPricePerSqFeetDataXaxis"
                  >
                  </app-line-chart> -->
                    <div class="high-graph" id="medianSoldPricePerSqFeetContainer">
                      <highcharts-chart
                        [Highcharts]="Highcharts"
                        [options]="medianSoldPricePerSqFeetChart"
                        style="width: 100%; height: 400px; display: block"
                      >
                      </highcharts-chart>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-6 col-12">
            <h4 class="mb-3 headWrap">Inventory by Property Type</h4>
            <table cellpadding="5" class="table table-bordered w_100">
              <tbody>
                <tr>
                  <td>
                    <!-- <app-line-chart
                    *ngIf="inventoryData.length != 0"
                    [chartData]="inventoryData"
                    [chartSettings]="inventoryDataXaxis"
                  >
                  </app-line-chart> -->
                    <div class="high-graph" id="inventoryContainer">
                      <highcharts-chart
                        [Highcharts]="Highcharts"
                        [options]="inventoryChart"
                        style="width: 100%; height: 400px; display: block"
                      >
                      </highcharts-chart>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-12">
            <h4 class="mb-3 headWrap">Median List Price vs. Median Sold Price</h4>
            <table cellpadding="5" class="table table-bordered w_100">
              <tbody>
                <tr>
                  <td>
                    <!-- <app-line-chart
                    *ngIf="medianListandSoldPriceData.length != 0"
                    [chartData]="medianListandSoldPriceData"
                    [chartSettings]="medianListandSoldPriceDataXaxis"
                  >
                  </app-line-chart> -->
                    <div class="high-graph" id="medianListPriceVsMedianSoldPriceContainer">
                      <highcharts-chart
                        [Highcharts]="Highcharts"
                        [options]="medianListPriceVsMedianSoldPriceChart"
                        style="width: 100%; height: 400px; display: block"
                      >
                      </highcharts-chart>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-6 col-12">
            <h4 class="mb-3 headWrap">Inventory and Absorption Rate</h4>
            <table cellpadding="5" class="table table-bordered w_100">
              <tbody>
                <tr>
                  <td>
                    <!-- <app-line-chart
                    *ngIf="inventoryAndAbsorptionDataForChart.length != 0"
                    [chartData]="inventoryAndAbsorptionDataForChart"
                    [chartSettings]="inventoryAndAbsorptionDataXaxis"
                  >
                  </app-line-chart> -->
                    <div class="high-graph" id="inventoryVsAbsorptionContainer">
                      <highcharts-chart
                        [Highcharts]="Highcharts"
                        [options]="inventoryVsAbsorptionChart"
                        style="width: 100%; height: 400px; display: block"
                      >
                      </highcharts-chart>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
